import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import TimelineItem from './TimelineItem';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';

var Timeline = function Timeline(props) {
  var _context, _context2, _context3, _classNames;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var _a = getCompProps('Timeline', userDefaultProps, props),
      customizePrefixCls = _a.prefixCls,
      _a$pending = _a.pending,
      pending = _a$pending === void 0 ? null : _a$pending,
      pendingDot = _a.pendingDot,
      children = _a.children,
      className = _a.className,
      reverse = _a.reverse,
      mode = _a.mode,
      style = _a.style,
      lineHeight = _a.lineHeight,
      labelWidth = _a.labelWidth,
      restProps = __rest(_a, ["prefixCls", "pending", "pendingDot", "children", "className", "reverse", "mode", "style", "lineHeight", "labelWidth"]);

  var prefixCls = getPrefixCls(pkgPrefixCls, 'timeline', customizePrefixCls);
  var pendingNode = typeof pending === 'boolean' ? null : pending;
  var pendingItem = pending ? /*#__PURE__*/React.createElement(TimelineItem, {
    pending: !!pending,
    dot: pendingDot || /*#__PURE__*/React.createElement(Icon, {
      type: "loadding",
      spin: true
    })
  }, pendingNode) : null;
  var timeLineItems = reverse ? _concatInstanceProperty(_context = [pendingItem]).call(_context, _toConsumableArray(React.Children.toArray(children).reverse())) : _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(React.Children.toArray(children)), [pendingItem]);

  var truthyItems = _filterInstanceProperty(timeLineItems).call(timeLineItems, function (item) {
    return !!item;
  });

  var itemsCount = React.Children.count(truthyItems);

  var items = _mapInstanceProperty(_context3 = React.Children).call(_context3, truthyItems, function (ele, index) {
    var pendingClass = index === itemsCount - 2 ? 'last' : '';
    var readyClass = index === itemsCount - 1 ? 'last' : '';
    return /*#__PURE__*/React.cloneElement(ele, {
      className: classNames([ele.props.className, !reverse && !!pending ? pendingClass : readyClass])
    });
  });

  var hasLabelItem = truthyItems.some(function (item) {
    return !!item.props.label;
  });
  var classString = classNames(prefixCls, (_classNames = {
    pending: !!pending,
    reverse: !!reverse
  }, _defineProperty(_classNames, mode, mode), _defineProperty(_classNames, "label", hasLabelItem), _classNames), className);

  var styleString = _extends(_extends({}, style), {
    paddingLeft: hasLabelItem && mode === 'left' ? "".concat(labelWidth, "px") : undefined,
    paddingRight: hasLabelItem && mode === 'right' ? "".concat(labelWidth, "px") : undefined
  });

  return /*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
    className: classString,
    style: styleString
  }), items === null || items === void 0 ? void 0 : _mapInstanceProperty(items).call(items, function (item) {
    return /*#__PURE__*/React.cloneElement(item, {
      mode: mode,
      labelWidth: labelWidth,
      lineHeight: lineHeight,
      label: item.props.label || hasLabelItem && ' '
    });
  }));
};

Timeline.displayName = 'Timeline';
Timeline.Item = TimelineItem;
export default Timeline;